import { gql } from 'apollo-boost';

export const GET_ALL_USERS = gql`
    query ($data: GetAllUsersInput!) {
        getAllUsers(data: $data) {
            users {
                id
                email
                fullName
                isVerified
                role
                createdAt
                updatedAt
                planType
                quota {
                    maxMessages
                    totalMessages
                    maxStorage
                    totalStorage
                    maxFileSize
                    maxCredits
                    credits
                }
                profilePictureUrl
                isSubscribedToNewsletter
                analytics {
                    homeFolderCount
                    subfolderCount
                    trashedFolderCount
                    totalInboxMessages
                    totalInboxTrashedMessages
                    totalTrashedMessages
                }
                settings {
                    usedMacApp
                    usedWindowsApp
                    usedAndroidApp
                    usedLinuxApp
                    usedIosApp
                    usedDesktopWebApp
                    usedClipper
                }
                usage {
                    lastLogin
                    lastActive
                    lastActiveDesktop
                    lastActiveMobile
                    lastFolderCreation
                    lastFolderUpdate
                    lastFolderMove
                    lastMessageCreation
                    lastMessageUpdate
                    lastMessageMove
                    totalLoginsDesktop
                    totalLoginsMobile
                    totalFolderViews
                    totalStarViews
                    totalTaskViews
                    totalMessageViews
                    totalSearchViews
                    totalFilterViews
                    totalInboxCreatedMessages
                    totalInboxMobileCreatedMessages
                    totalImageMessages
                    totalFileMessages
                    totalUrlMessages
                    totalNoteMessages
                    totalTaskMessages
                    totalStarMessages
                    totalExtensionCreatedMessages
                    totalMobileExtensionCreatedMessages
                    totalPermanentlyDeletedMessages
                    totalAiCalls
                    totalAiPromptTokens
                    totalAiCompletionTokens
                    totalAiTokens
                    totalCreditsSpent
                    totalAiEstimatedCostUsd
                    lastAiUsageAt
                }
            }
            cursor
        }
    }
`;
